import React, {useContext, useEffect, useState} from "react";
import {Col, Row, Tab, Tabs} from "react-bootstrap";
import {CatalogModalViewHeader} from "../../../Shared/CatalogModalViewHeader";
import {NFTextInput} from "../../../Shared/NewForms/NFTextInput";
import {FormProvider, useForm} from "react-hook-form";
import {NewCatalogModalViewContext} from "../../../Shared/NewCatalogModalView";
import {NFLookupCurrency} from "../../../Shared/NewForms/NFlookupCurrency";
import {NFCheckBoxInput} from "../../../Shared/NewForms/NFCheckBoxInput";
import {NFLookupProduct} from "../../../Shared/NewForms/NFLookupProduct";
import ProductGroupDetailSkeleton from "./ProductGroupDetailSkeleton";
import {ProductTypeEnum} from "../../../../enums/Products/ProductTypeEnum";
import {IProductDto} from "../../../../dtos/catalogs/Products/IProductDto";
import {DocumentSaveActionType} from "../../../../helpers/DocumentHelper";

interface IProps {
    model: IProductDto | null;
    modelUpdatedEvent: (newModel: IProductDto) => void;
}

interface ProductModel {
    id: string;
    name: string;
    uniqueCode?: string;

    isGroup?: boolean;
    parentId?: string;
}

export const ProductGroupDetail = ({model, modelUpdatedEvent}: IProps) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [selectedOpType, setSelectedOpType] = useState(0);
    const handleTypeChange = (value: any) => {
        setSelectedOpType(value);
    };

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
        reset,
        formState,
        getValues,
        watch,
        control,
        trigger,
        ...methods
    } = useForm<ProductModel>();

    const modalViewContext = useContext(NewCatalogModalViewContext);
    const {saveHandler, closeHandler} = modalViewContext;

    useEffect(() => {
        if (model) {
            setValue("id", model.id);
            setValue("name", model.name);
            setValue("isGroup", model.isGroup);
            setValue("parentId", model.parentId);
        }
    }, [model]);

    const handleFormSubmit = async (action: DocumentSaveActionType, data: ProductModel) => {
        console.log("form submit start");
        console.log(data);
        console.log(action);
        // return;
        if (action === "save") {
            const newModel: IProductDto = {...model, ...data};
            console.log("new model");
            console.log(newModel);
            // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
            await saveHandler(newModel);
        }
    };

    if (!model) {
        return (
            <>
                <ProductGroupDetailSkeleton/>
            </>
        );
    }

    const handleTabChange = (index: number) => {
        setTabIndex(index);
    };

    return (
        <FormProvider
            getValues={getValues}
            setValue={setValue}
            register={register}
            control={control}
            trigger={trigger}
            reset={reset}
            watch={watch}
            handleSubmit={handleSubmit}
            formState={formState}
            {...methods}
        >
            <div style={{height: "600px"}}>
                <div className="d-flex" style={{gap: "12px"}}>
                    <button
                        onClick={() => handleTabChange(0)}
                        className={`btn ${tabIndex === 0 ? "custom-btn" : "btn btn-light"}`}
                    >
                        Main
                    </button>
                </div>
                <CatalogModalViewHeader
                    onSave={handleSubmit((data) => handleFormSubmit("save", data))}
                    onClose={closeHandler}
                />
                <div className="panel panel-primary tabs-style-2">
                    <div className=" tab-menu-heading">
                        <div className="tabs-menu1">
                            <Tabs
                                defaultActiveKey="0"
                                activeKey={tabIndex}
                                className=" panel-tabs main-nav-line "
                            >
                                <Tab eventKey="0" title={undefined}>
                                    <Row>
                                        <Col sm={6}>
                                            <NFTextInput title={"Name"} fieldName={"name"}/>
                                        </Col>
                                        <Col sm={6}>
                                            <NFTextInput
                                                title={"Unique code"}
                                                fieldName={"uniqueCode"}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}>
                                            <NFLookupProduct
                                                title="Choose Folder"
                                                fieldName="parentId"
                                            />
                                        </Col>
                                    </Row>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </FormProvider>
    );
};
